export interface PricingPack {
  name: string;
  reports: number;
  price: number;
  perReport: string;
  popular: boolean;
}

export const pricingPacks: PricingPack[] = [
  { name: 'Starter', reports: 50, price: 55, perReport: '1.10', popular: false },
  { name: 'Standard', reports: 250, price: 225, perReport: '0.90', popular: true },
  { name: 'Professional', reports: 500, price: 375, perReport: '0.75', popular: false },
  { name: 'Enterprise', reports: 1000, price: 650, perReport: '0.65', popular: false },
];
